
import { Component, Input } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'atw-messenger',
  templateUrl: './messenger.component.html',
  styleUrls: ['./messenger.component.scss']
})

export class AtwMessengerAdmin {
  @Input() data: any; // dữ liệu của object từ block truyền vào gồm {_id, component, desktop_position, mobile_position, x, y, rows, cols, z_index}
  
  /**
   * Biến này để chứa dữ liệu của this.data.data
   * Lưu ý: không thể gộp 2 trường _id và id_object (gán _id=id_object và xóa id_object) vì:  không cho phép chỉ định _id khi gán  
   */
  data_object: any = {
    data: {
      link: '',
      hyper_link: '',
    },
  };
  isVisible = false; // Biến check ẩn hiện modal
  loading = false; //Biến check loading

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb, 
    private message: NzMessageService
  ) { }


  ngOnChanges() {
    this.data_object.data = this.data.staticdata;
  }
  
  
   

  /**
   * Kiểm tra xem object đã tồn tại hay chưa, nếu chưa thì add, tồn tại rồi thì update
   * @param value 
   */
  updateOrAdd(value) {
      this.vhQueryAutoWeb
        .updateObject(this.data._id, value)
        .then(
          (bool: any) => {
            if(bool.vcode === 0) {
              this.createMessage('success', 'Cập nhật thành công');
            }
            else {
              this.createMessage('error', 'Cập nhật thất bại');
            }
          },
          (error) => {
            this.createMessage('error','Xảy ra lỗi trong quá trình cập nhật');
            console.log('error', error);
          }
        );
  }


  /**
   * Hàm hiển thị thông báo
   * @param type 
   * @param content 
   * @param duration 
   */
  createMessage(type: 'success' | 'error' | 'warning' | 'info', content: string, duration: number = 2000): void {
    this.message.create(type, content, {
      nzDuration: duration,
    });
  }


  showModal(): void {
    this.isVisible = true;
  }


  handleOk(): void {
    this.isVisible = false;
  }


  handleCancel(): void {
    this.isVisible = false;
  }

}
